import ReactGA from 'react-ga4';

// Single source of truth for the GA4 measurement ID.
// The matching script tag in public/index.html must use the same ID.
export const GA_MEASUREMENT_ID = 'G-SKNP5N337Q';

ReactGA.initialize(GA_MEASUREMENT_ID);

const EVENT_NAME = 'render_ideogram';
const EVENT_CATEGORY = 'image_generation';

interface BaseRenderParams {
  file_format: string;
  is_preview_only: boolean;
  has_custom_cytoband: boolean;
  has_genes_file: boolean;
  excluded_chromosome_count: number;
  excluded_abnormality_count: number;
}

interface RenderFailedParams extends BaseRenderParams {
  error_message: string;
}

export const trackRenderStarted = (params: BaseRenderParams): void => {
  ReactGA.event(EVENT_NAME, {
    event_category: EVENT_CATEGORY,
    status: 'started',
    ...params,
  });
};

export const trackRenderSuccess = (params: BaseRenderParams): void => {
  ReactGA.event(EVENT_NAME, {
    event_category: EVENT_CATEGORY,
    status: 'success',
    ...params,
  });
};

export const trackRenderFailed = (params: RenderFailedParams): void => {
  ReactGA.event(EVENT_NAME, {
    event_category: EVENT_CATEGORY,
    status: 'error',
    ...params,
  });
};

export const trackImageDisplayed = (
  params: Pick<BaseRenderParams, 'file_format' | 'is_preview_only'>,
): void => {
  ReactGA.event(EVENT_NAME, {
    event_category: EVENT_CATEGORY,
    status: 'displayed',
    ...params,
  });
};
